// import React from 'react';
import { locationGetStringifiedSearchParams } from 'src/utils/location/get-stringified-search-params';
import { InboxListParams, ListOrderTypes } from './store';
import queryString from 'query-string';
import isEmpty from 'lodash/isEmpty';

interface Props extends InboxListParams {}

interface UrlFilterParams {
  list_type: string;
  order_by: ListOrderTypes;
  sort_name: string;
}

const getNotEmptyParams = <T extends object>(value: T): Partial<T> =>
  Object.entries(value)
    .filter(([, value]) => !isEmpty(value))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

export const useDashboardInboxSerializeFilter = (searchString: string) => ({
  serializeFilter: (params: Props) =>
    locationGetStringifiedSearchParams(searchString, {
      order_by: params.orderBy,
      sort_name: params.sortName,
    }),
  deserializeFilter: (filterStr: string): Partial<Props> => {
    const urlParams = queryString.parse(filterStr) as Partial<UrlFilterParams>;
    const notEmptyParams = getNotEmptyParams(urlParams);

    return {
      orderBy: notEmptyParams.order_by,
      sortName: notEmptyParams.sort_name,
    };
  },
});
